// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatVirtualList_chats__xseKv {
  max-height: 100%;
  overscroll-behavior-y: none;
  flex-grow: 1;
}
.ChatVirtualList_chats__list__oiaxe {
  overscroll-behavior-y: none;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ChatVirtualList/ChatVirtualList.module.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EAGA,2BAAA;EACA,YAAA;AAHF;AAUE;EAGE,2BAAA;AAVJ","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.chats {\n  max-height: 100%;\n  //overflow-y: scroll;\n  //overflow-x: hidden;\n  overscroll-behavior-y: none;\n  flex-grow: 1;\n\n\n  //touch-action: none;\n\n  //@include invisible-scroll;\n\n  &__list {\n    //@include invisible-scroll;\n\n    overscroll-behavior-y: none;\n\n    //flex-grow: 1;\n    //display: flex;\n    //flex-direction: column;\n    //align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chats": `ChatVirtualList_chats__xseKv`,
	"chats__list": `ChatVirtualList_chats__list__oiaxe`
};
export default ___CSS_LOADER_EXPORT___;
